import type { User } from '@repositories/userRepository/user.types';

/**
 * 백엔드 응답으로부터 제한 토큰 여부를 판정
 * - limitedToken === true: 명시적 제한 토큰
 * - limitedToken === false: 명시적 풀 토큰 (AP 없어도 풀 토큰)
 * - limitedToken === undefined + AP 없음: 제한 토큰으로 간주 (하위 호환)
 */
export const isLimitedTokenResponse = (
  user: Pick<User, 'limitedToken' | 'additionalPermissions'>,
): boolean => {
  const hasNoPermissions = !user.additionalPermissions || user.additionalPermissions.length === 0;
  return user.limitedToken === true || (user.limitedToken !== false && hasNoPermissions);
};
